import axios, * as others from 'axios';
import { computed, makeAutoObservable, observable } from "mobx";

const create_axios_instance = (token) => {
    return axios.create({
        baseURL: process.env.REACT_APP_API_URL,
        headers: {
            'accept': 'application/json',
            'Authorization': `Bearer ${token}`
        }
    });
}

class AxiosStore {
    accessToken = null

    constructor() {
        makeAutoObservable(this, {
            accessToken: observable,
            isAuthenticated: computed
        });
        this.baseAxios = null
    }

    get isAuthenticated() {
        const decodedAccessToken = this.accessToken ? JSON.parse(atob(this.accessToken.split('.')[1])) : null;
        const currentTime = Math.floor(Date.now() / 1000); // Current time in seconds
        return decodedAccessToken?.exp > currentTime; // Check if the token is still valid
    }

    setAccessToken(token){
        // this.baseAxios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        this.baseAxios = create_axios_instance(token)
        this.accessToken = token;
    }

    signout(){
        this.accessToken = null
    }
}

export default AxiosStore;
